const IMAGES = {
    "Expense Tracker": require('./Expense-Tracker.jpg'),
    "Calculator": require('./Calculator.png'),
    "Meme boss": require('./Meme-boss.jpg'),
    "Rock-Paper-Scissors": require('./Rock-Paper-Scissors.png'),
    "Digital clock": require('./Digital-clock.png'),
    "Todo list": require('./Todo-list.png'),
}

export default IMAGES;